import { useState, useEffect, useCallback } from 'react';
import { ordersApi } from '@/services/api';

export const useOrderState = () => {
  const [order, setOrder] = useState(null);
  const [localData, setLocalData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async (id) => {
    try {
      const res = await ordersApi.getById(id);
      setOrder(res.data);
      return res.data;
    } catch (err) {
      setError(err);
      return null;
    }
  }, []);

  useEffect(() => {
    const stored = localStorage.getItem('arman_order');
    if (!stored) {
      setLoading(false);
      return;
    }
    const local = JSON.parse(stored);
    setLocalData(local);
    refresh(local.orderId).finally(() => setLoading(false));
  }, [refresh]);

  const updateLocalData = (data) => {
    const newData = { ...localData, ...data };
    setLocalData(newData);
    localStorage.setItem('arman_order', JSON.stringify(newData));
  };

  return { order, setOrder, localData, loading, error, refresh, updateLocalData };
};
